import VueRouter from 'vue-router'

const Home = () => import(/* webpackChunkName: "home" */ './views/Home')
const Access = () => import(/* webpackChunkName: "access" */ './views/Access')

const routes = [
  { path: '/', component: Home },
  { path: '/access', component: Access },
  { path: '*', redirect: '/' },
]

export const router = new VueRouter({
  mode: 'history',
  routes,
})
